import { EntityService } from '../../../service/EntityService';

export class PriceService extends EntityService {

  static entity = 'api/app/price';

}
